export default __webpack_public_path__ + "static/media/1.6df597b3.png";